import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'

export class PrincipalMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  companyDetailsName = ''
  companyDetailsCode = ''
  adviserCode = ''
}
